module.exports = __webpack_public_path__ + "img/dirndl-stine-50-cm–pink.c22dc0d2.png";